@if (!useSummaryView) {
    @if (!field.hidden) {
        <div class="flex flex-col w-full" animate.enter="fade-in">
            <span class="mb-1">{{ field.label | localize }}</span>
            <div class="flex gap-2 flex-full h-fit">
                @for (option of weekDaysOptions(); track option.code) {
                    <div class="border rounded-md flex items-center justify-center cursor-pointer w-10 4xl:w-12 h-8 4xl:h-10" 
                        [ngClass]="{ 'bg-primary text-on-primary': weekDayIsSelected(option.code), 'border-red-500 text-red-500': field.required && !field.control.value?.length }"
                        (click)="toggleWeekDay(option.code)">
                        {{ 'weekdays.abbr_' + option.code | transloco }}
                    </div>
                }
            </div>
            @if (field.hint) {
                <span class="mt-1 text-hint">{{ field.hint | localize }}</span>
            }
        </div>
    }
} @else {
    {{ toSummaryView() }}
}